import { TranslateService } from "@ngx-translate/core";
import { entryProp } from "../../../interfaces/apiCalls";
import { getAddressSchema } from "../address-search/address-FE-schema";

export const getUserSchemaData = (translate : TranslateService): entryProp[] => [
  {
    name: "firstName",
    label: translate.instant('dict.firstName'),
    type: "string",
    required: true,
    helpMessage: translate.instant('terms.firstNameOf'),
  },
  {
    name: "lastName",
    label: translate.instant('dict.lastName'),
    type: "string",
    required: true,
    helpMessage: translate.instant('terms.lastNameOf'),
  },
  {
    name: "username",
    label: translate.instant('dict.userName'),
    type: "string",
    minLength: 7,
    required: true,
    helpMessage: translate.instant('infoBubbles.username'),
    unique: true, // this field is unique in the backend
  },
  {
    name: "email",
    label: translate.instant('dict.email'),
    type: "email",
    minLength: 6,
    required: true,
    helpMessage: translate.instant('infoBubbles.email'),
    unique: true, // this field is unique in the backend
  },
  {
    name: "password",
    label: translate.instant('dict.password'),
    required: true,
    type: "password",
    minLength: 8,
    helpMessage: translate.instant('infoBubbles.password'),
  },
  {
    name: "validuntil",
    label: translate.instant('dict.validUntil'),
    type: "dateAfter",
    required: true,
    helpMessage: translate.instant('infoBubbles.validUntil'),
  },
  {
    name: "role",
    label: translate.instant('dict.role'),
    type: "options",
    helpMessage:  translate.instant('infoBubbles.role'),
    required: true,
    options: [
              {value: "authenticated", label: translate.instant('dict.authenticated')}, 
              {value: "assistant",     label: translate.instant('dict.assistant')}],
    skipValidation: true, // this is a workaround for the fact that the backend does not validate this field
  },
  {
    name: "matricule",
    label: translate.instant('dict.matricule'),
    type: "matricule",
    required: true,
    helpMessage: translate.instant('infoBubbles.matricule'),
    unique: true, // this field is unique in the backend
    
  },

  {
    name: "phone",
    label: translate.instant('dict.phoneNumber'),
    type: "number",
    required: true,
    helpMessage: translate.instant('infoBubbles.phoneNumber'),
  },
  {
    name: "birthDate",
    label: translate.instant('dict.birthDate'),
    type: "dateBefore",
    required: true,
    helpMessage: translate.instant('infoBubbles.birthDate'),
  },
  {
    name: "mobile",
    label: translate.instant('dict.mobilePhoneNumber'),
    type: "string",
    required: true,
    helpMessage: translate.instant('dict.mobilePhoneNumber'),
  },
  {
    name: "notes",
    label: translate.instant('dict.notes'),
    type: "text",
    required: false,
    helpMessage: translate.instant('dict.notes'),
  },
  ...getAddressSchema(translate),
];
